export function parseLocalDate(d) {
  if (!d) return null;
  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(d);
  if (iso) {
    return new Date(parseInt(iso[1]), parseInt(iso[2]) - 1, parseInt(iso[3]));
  }
  const us = /^(\d{2})\/(\d{2})\/(\d{4})/.exec(d);
  if (us) {
    return new Date(parseInt(us[3]), parseInt(us[1]) - 1, parseInt(us[2]));
  }
  return null;
}
